<template>
	<div>
		<main style='background: #EEEEEE;height: 700px;padding: 20px 0;padding-bottom: 60px;'>
			<div class="centerBox">
				<div class="liucheng">
					<div>
						<ul>
							<li @click="select(item, index)" v-for="(item, index) in list" :key="index"
								:class="{ active: activeNum === index }">{{ item.name }}</li>
						</ul>
						<div style="float: right;background: #fff;height: 100%;">
							<div class="boxItems" v-if="activeNum === 0">
								<div class="boxItem">
									<p>联系人姓名：</p>
									<el-input v-model="realName" placeholder="请输入联系人姓名"></el-input>
								</div>
								<div class="boxItem">
									<p>个人证件号码：</p>
									<el-input v-model="certificateNo" placeholder="请输入个人证件号码"></el-input>
								</div>
								<div class="boxItem">
									<p>证据所属类别：</p>
									<el-select v-model="evidenceType" placeholder="请选择问题类别" @change="getOrgan(evidenceType)">
										<el-option v-for="item in options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
								<div class="boxItem">
									<p>鉴定机构选择：</p>
									<el-select v-model="organNo" placeholder="请选择鉴定机构" @change="getOrganType(organNo)">
										<el-option v-for="item in options1" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
								<div class="boxItem">
									<p>标题：</p>
									<el-input v-model="caseTitle" placeholder="请输入标题"></el-input>
								</div>
								<div class="boxItem">
									<p>鉴定项目描述及原因：</p>
									<el-input type="textarea" placeholder="请输入鉴定项目描述及原因" v-model="appraisalReason"
										maxlength="40" show-word-limit>
									</el-input>
								</div>
								<div class="boxItem">
									<p>固定电话：</p>
									<el-input v-model="areaCode" placeholder="请输入区号" style="width: 160px;"></el-input>
									<span style="color: #999999;margin-left: 10px;">—</span>
									<el-input v-model="fixedPhone" placeholder="请输入电话号" style="width: 218px;"></el-input>
								</div>
								<div class="boxItem">
									<p>手机号：</p>
									<el-input v-model="phone" placeholder="请输入手机号"></el-input>
								</div>
								<div class="boxItem">
									<p>电子邮箱：</p>
									<el-input v-model="email" placeholder="请输入电子邮箱"></el-input>
								</div>
								<p class="btn" @click="order">确定提交</p>
							</div>
							<div class="boxItems" style="padding: 30px;" v-if="activeNum === 1 || activeNum === 2 ||activeNum === 3">
								<div class="tableBox">
									<ul class="tableBox_th">
										<li>编号</li>
										<li>鉴定项目</li>
										<li>状态</li>
									</ul>
									<p v-if="tableData.length ==0" class="noData">暂无数据</p>
									<ul class="tableBox_tr" v-for="(item, index) in tableData">
										<li>{{item.id}}</li>
										<li v-if="item.evidenceType == 1">法医类</li>
										<li v-if="item.evidenceType == 2">声像资料类</li>
										<li v-if="item.evidenceType == 3">物证类</li>
										<li v-if="item.evidenceType == 4">境损害类</li>
										<li v-if="item.caseStatus == 1">已受理</li>
										<li v-if="item.caseStatus == 2">未受理</li>
										<li v-if="item.caseStatus == 3">退回</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	import navheader from '../../components/navheader.vue'
	import footeritem from '../../components/footeritem.vue'
	import axios from 'axios'
	import '../../assets/css/index.less'
	import '../../assets/css/fuWu.less';
	export default {
		name: 'Pdf',
		components: {
			navheader,
			footeritem
		},
		data() {
			return {
				dialogVisible:true,
				tableData:'',
				realName:'',
				appraisalReason: '',
				areaCode: '',
				fixedPhone: '',
				caseStatus: '',
				certificateNo: '',
				email: '',
				evidenceType: '',
				id: '',
				organNo: '',
				phone: '',
                                caseTitle:'',
				options: [{
						value: '1',
						label: '法医类'
					},
					{
						value: '2',
						label: '物证类'
					},
					{
						value: '3',
						label: '声像资料类'
					}, {
						value: '4',
						label: '环境损害类'
					}
				],
				options1: [{
						value: '1',
						label: ' 河北华科大司法鉴定中心'
					},
					{
						value: '2',
						label: '燕赵司法鉴定中心'
					},
					{
						value: '3',
						label: '中经天平司法鉴定中心'
					}, {
						value: '4',
						label: '河北中旭生态环境损害司法鉴定中心'
					}
				],
				value: '',
				activeNum: 0,
				list: [{
						name: '我要鉴定'
					},
					{
						name: '已受理订单'
					},
					{
						name: '未受理订单'
					},
					{
						name: '退回订单'
					},
					// {
					// 	name: '个人信息'
					// },
					{
						name: '退出系统'
					},
				],
			};
		},
		methods: {
			// 左侧tab标签切换
			select(item, index) {
				this.activeNum = index
				switch (index){
					// case 4:
					// this.info()
					// break;
					case 4:
					this.logout()
					break;
					default:
					this.listByStatus(index)
					break;
				}
				// if (index === 4) {
				// 	this.info()
				// }
			},

            getOrgan(value){
            this.organNo=value
            },
            getOrganType(value){
                this.evidenceType=value
            },
			order() {
				var that = this
				var telRex = /^1(3|4|5|6|7|8|9)\d{9}$/;
				var emailRex = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
				// 正则表达式：
				var idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
				if (that.realName == '') {
					this.$message({
						message: '姓名不能为空',
						type: 'warning'
					});
					return false;
				} else if (that.certificateNo == '') {
					this.$message({
						message: '证件号不能为空',
						type: 'warning'
					});
					return false;
				}else if (!idcardReg.test(that.certificateNo)) {
					this.$message({
						message: '输入的证件号有误',
						type: 'warning'
					});
					return false;
				}else if (that.evidenceType == '') {
				 	this.$message({
				 		message: '请选择所属类别',
				 		type: 'warning'
				 	});
				 	return false;
				 }else if (that.organNo == '') {
					this.$message({
						message: '请选择鉴定机构',
						type: 'warning'
					});
					return false;
				}else if (that.title == '') {
					this.$message({
						message: '标题不能为空',
						type: 'warning'
					});
					return false;
				} else if (that.appraisalReason == '') {
					this.$message({
						message: '鉴定原因不能为空',
						type: 'warning'
					});
					return false;
				}else if (that.phone == '') {
					this.$message({
						message: '手机号不能为空',
						type: 'warning'
					});
					return false;
				} else if (!telRex.test(that.phone)) {
					this.$message({
						message: '输入的手机号有误',
						type: 'warning'
					});
					return false;
				}else if (that.email == '') {
					this.$message({
						message: '邮箱不能为空',
						type: 'warning'
					});
					return false;
				}else if (!emailRex.test(that.email)) {
					this.$message({
						message: '输入的邮箱有误',
						type: 'warning'
					});
					return false;
				}
				var params = new URLSearchParams();
				axios.post('/system/order/addCaseOrder', {
					'realName': that.realName,
					'caseTitle': that.title,
					'fixedPhone': that.fixedPhone,
					'phone': that.phone,
					'areaCode': that.areaCode,
					'certificateNo': that.certificateNo,
					'organNo': that.organNo,
                    'caseTitle':that.caseTitle,
					'appraisalReason': that.appraisalReason,
					'email': that.email,
					'evidenceType': that.evidenceType
				}, {
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'Customer-Token':localStorage.getItem('token')
					}
				}).then(res => {
					if (res.data.code == 200) {
                        this.activeNum = 2
                        this.listByStatus(2)
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.activeNum = 2
						// this.$router.push('/')
					}else if(res.data.code == 203){
						this.$message({
							message: '登录失效，请重新登录',
							type: 'warning'
						});
						that.$router.push('/jdapply')
					}
				}, err => {})
			},
			// 案件受理列表查询
			listByStatus(caseStatus ) {
				var params = new URLSearchParams();
				axios.get('/system/order/listByStatus?caseStatus=' + caseStatus,{
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'Customer-Token':localStorage.getItem('token')
					}
				} ).then(res => {

					if (res.data.code === 200) {
						this.tableData = res.data.data
					}else if(res.data.code === 203){
                        this.$message({
                            message: '登录失效，请重新登录',
                            type: 'warning'
                        });
                        this.$router.push('/jdapply')
                    }
				}, err => {})
			},
			tableRowClassName({row, rowIndex}) {
			        if (rowIndex === 1) {
			          return 'warning-row';
			        } else if (rowIndex === 3) {
			          return 'success-row';
			        }
			        return '';
			      },
			// 个人信息
			info() {
				var that = this
				var params = new URLSearchParams();
				axios.post('/system/customer/info', {}, {
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'Customer-Token':localStorage.getItem('token')
					}
				}).then(res => {
					if (res.data.code == 200) {
						// this.$message({
						// 	message: '注册成功',
						// 	type: 'success'
						// });

						// this.$router.push('/jdapply')
						// this.personBox = res.data.rows.slice(0,6)
					}
				}, err => {})
			},
			// 退出系统
			logout() {
                this.$confirm('确定要退出系统吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post('/system/customer/logout', {}, {
                        headers: {
                            'Content-Type': 'application/json;charset=UTF-8'
                        }
                    }).then(res => {
                        if (res.data.code == 200) {
                            localStorage.clear()
                            this.$message({
                                message: '退出成功',
                                type: 'success'
                            });
                            this.$router.push('/jdapply')
                        }
                    }, err => {})
                }).catch(() => {

                });

			}
		},
		created() {

		},
		mounted() {
			let that = this;
		},
	};
</script>

<style lang="less" scoped="scoped">
	.tableBox{
		width: 92%;
		overflow: hidden;
		.noData{
			width: 100%;
			height: 100px;
			line-height: 100px;
			text-align: center;
		}
		.tableBox_th{
			width: 100%;
			height: 40px;
			background: #e9eaeb;
			// padding: 0 34px;
			box-sizing: border-box;
			li{
				float: left;
				color: #999999;
				line-height: 40px;
				text-align: center;
				width: 25%;
				&:nth-of-type(2){
					width: 50%;
				}
			}
		}
		.tableBox_tr{
			width: 100%;
			height: 50px;
			border-bottom: 1px dashed  #C0BFBB;
			// padding: 0 34px;
			box-sizing: border-box;
			li{
				float: left;
				color: #999999;
				line-height: 50px;
				text-align: center;
				width: 25%;
				&:nth-of-type(2){
					width: 50%;
				}
			}
		}

	}
	.el-table .warning-row {
	    background: oldlace;
	  }

	  .el-table .success-row {
	    background: #f0f9eb;
	  }
	.topImg {
		width: 100%;
		display: block;
	}

	.centerBox {
		width: 1134px;
		margin: 0 auto;
		overflow: hidden;
		box-sizing: border-box;
	}

	.titleTip {
		width: 100%;
		border-left: 4px solid #01458E;
		padding-left: 10px;
	}

	.liucheng {

		// background: #F8F8F8;
		// padding: 30px 0;
		&>div {
			width: 1200px;
			height: 700px;
			margin: 0 auto;
			box-shadow: 0px 0px 0px NaNpx rgba(4, 32, 89, 0.15);
			box-sizing: border-box;
			// background: #fff;
			overflow: hidden;

			&>ul {
				float: left;
				padding: 50px;
				box-sizing: border-box;
				background: #fff;
				height: 100%;

				&>li {
					width: 150px;
					line-height: 50px;
					text-align: center;
					cursor: pointer;
					position: relative;

					&::after {
						position: absolute;
						right: -16px;
						top: 16px;
						display: inline-block;
						content: '';
						border: 8px solid transparent;
					}

					&.active {
						background: #076CE0;
						color: #fff;

						&::after {
							border-left-color: #076CE0;
						}
					}
				}
			}

			&>div {
				width: calc(100% - 300px);
				box-sizing: border-box;
				padding-top: 0;
				float: right;
				overflow: hidden;

				.lianxi {
					p {
						span {
							display: inline-block;
							width: 80px;
							text-align: right;
							margin-right: 20px;
						}

						margin-top: 20px;
					}
				}
			}

			.title {
				width: 100%;
				height: 67px;
				line-height: 67px;
				background: #0068d8;
				padding: 0 30px;
				box-sizing: border-box;
				font-size: 22px;
				font-family: Microsoft YaHei, Microsoft YaHei-Bold;
				font-weight: 700;
				text-align: left;
				color: #ffffff;
				letter-spacing: 1px;
			}

			.boxItems {
				width: 100%;
				padding: 50px 130px;
				box-sizing: border-box;
				overflow: hidden;

				.boxItem {
					width: 100%;
					margin-bottom: 15px;
					overflow: hidden;
					display: flex;
					align-items: center;

					p {
						width: calc(20% - 15px);
						font-size: 16px;
						text-align: right;
						font-family: Microsoft YaHei, Microsoft YaHei-Regular;
						font-weight: 400;
						color: #666666;
					}

					.el-select,
					.el-input,
					.el-textarea {
						width: 420px;
						margin-left: 15px;
					}
				}

				.btn {
					width: 200px;
					height: 61px;
					line-height: 61px;
					background: #0068d8;
					border-radius: 15px;
					box-shadow: 0px 0px 0px NaNpx rgba(4, 32, 89, 0.15);
					font-size: 18px;
					font-family: Microsoft YaHei, Microsoft YaHei-Bold;
					font-weight: 700;
					text-align: left;
					color: #ffffff;
					margin: 0 auto;
					margin-top: 30px;
					text-align: center;
					cursor: pointer;
				}
			}

		}

		@media screen and (max-width: 1024px) {
			&>div {
				width: 90%;
			}
		}
	}
</style>
